export default "__VITE_ASSET__CJiDm5Ed__"